var extend = require("../general.js").extend;

// Creates a combined getter setter function for the this class
var getSetFunctionCreator = function(args){
    var getSetFunction = function(val){
        if (val !== undefined) return getSetFunction.set(val);
        else return getSetFunction.get();
    };
    extend(getSetFunction, this.prototype, true);   // extend the getSetFunction instance with the all the prototype functions of this class
    this.apply(getSetFunction, arguments);  // call the constructor of this class with the same arguments

    return getSetFunction;
};

module.exports = getSetFunctionCreator;